import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CurrencyBRLPipe} from './_helpers/currency-brl.pipe';
import {MessagePipe} from './_helpers/message.pipe';
import {ArredondarPipe} from './_helpers/arredondar.pipe';
import {PorcentagemPipe} from './_helpers/porcentagem.pipe';
import {DataBRPipe} from './_helpers/data-br.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    CurrencyBRLPipe,
    MessagePipe,
    ArredondarPipe,
    PorcentagemPipe,
    DataBRPipe
  ],
  declarations: [
    CurrencyBRLPipe,
    MessagePipe,
    ArredondarPipe,
    PorcentagemPipe,
    DataBRPipe
  ]
})
export class PoupexUtilModule { }
